if (!customElements.get('card-color-swatches')) {
  customElements.define('card-color-swatches', class extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const swatch = event.target.closest('button[data-variant-url]');
      if (!swatch || swatch.disabled || !swatch.dataset.variantUrl) return;
      const card = this.closest('.product-card-wrapper');
      if (!card) return;

      card.querySelectorAll('[data-product-link]').forEach(link => {
        link.href = swatch.dataset.variantUrl;
      });
      card.querySelectorAll('[data-product-url]').forEach(button => {
        button.dataset.productUrl = swatch.dataset.variantUrl;
      });
      const image = card.querySelector('.card__media img');
      if (image && swatch.dataset.variantImage) {
        image.removeAttribute('srcset');
        image.src = swatch.dataset.variantImage;
        image.alt = swatch.dataset.variantImageAlt || '';
        card.classList.add('card-color-selected');
      }
      this.querySelectorAll('button[data-variant-url]').forEach(button => {
        button.setAttribute('aria-pressed', String(button === swatch));
      });
    }
  });
}
